/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Students_admin = {|
  +allStudents: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +firstname: ?string;
        +lastname: ?string;
        +pendingJobRequestsCount: ?number;
        +startedJobsCount: ?number;
        +cellphoneNumber: ?string;
        +user: {|
          +email: string;
          +active: boolean;
          +status: string;
        |};
      |};
    |}>;
    +pageInfo: {|
      +hasNextPage: boolean;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "RootArgument",
      "name": "hasStartedJobs",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasPendingJobRequests",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "name",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "email",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "allStudents"
        ]
      }
    ]
  },
  "name": "Students_admin",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "allStudents",
      "args": [
        {
          "kind": "Variable",
          "name": "email",
          "variableName": "email",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "hasPendingJobRequests",
          "variableName": "hasPendingJobRequests",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "hasStartedJobs",
          "variableName": "hasStartedJobs",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "name",
          "variableName": "name",
          "type": "String"
        }
      ],
      "concreteType": "StudentConnection",
      "name": "__Students_allStudents_connection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "StudentEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Student",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "firstname",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "lastname",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "pendingJobRequestsCount",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "startedJobsCount",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "cellphoneNumber",
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "active",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "status",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Admin"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/student/__generated__/Students_admin.graphql.js